import { render, staticRenderFns } from "./cancellation-and-amendment-policy.vue?vue&type=template&id=fb793062&scoped=true"
import script from "./cancellation-and-amendment-policy.vue?vue&type=script&lang=ts"
export * from "./cancellation-and-amendment-policy.vue?vue&type=script&lang=ts"
import style0 from "./cancellation-and-amendment-policy.vue?vue&type=style&index=0&id=fb793062&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb793062",
  null
  
)

export default component.exports